let module = angular.module('app.resources');

module.factory('BroadcastTags', ($resource) => {
  'ngInject';
  return $resource(
    `${API_ROOT}/account/broadcast_tags/:id`,
    { id: '@id' },
    {
      query: {
        method: 'GET',
        url: `${API_ROOT}/account/broadcast_tags?l=1000`,
        isArray: true,
      },
    }
  );
});

export default module;



// WEBPACK FOOTER //
// ./app/resources/broadcast-tags.js